<template>
  <b-col
    class="d-flex flex-column"
    style="flex: auto; overflow-y:auto;"
    data-cy="agendar-container"
  >
    <div class="d-flex flex-row" data-cy="agendar-header-row">
      <back-button data-cy="agendar-back-button"></back-button>
      <div class="d-flex flex-column mb-4" data-cy="agendar-header-info">
        <h4 class="text-primary font-weight-bold" data-cy="agendar-title">
          Agendar
        </h4>
        <small data-cy="agendar-subtitle">
          Selecione abaixo
          <b data-cy="agendar-subtitle-bold">
            como deseja realizar seu atendimento
          </b>
        </small>
      </div>
    </div>

    <search-filter
      placeholder="Buscar profissional..."
      data-cy="agendar-search-filter"
    ></search-filter>

    <div
      class="accordion py-3"
      id="accordionExample"
      data-cy="agendar-accordion"
    >
      <loading-overlay
        v-if="isLoading"
        message="Carregando informações da agenda..."
        data-cy="agendar-loading-overlay"
      />
      <div v-else data-cy="agendar-agendas-list">
        <agenda-geral-main
          v-for="agenda in agendas"
          :key="agenda.id"
          :schedule="agenda"
          reschedule="false"
          :data-cy="`agendar-agenda-item-${agenda.id}`"
        />
        <div
          class="alert alert-primary"
          role="alert"
          v-if="
            lastDate &&
            agendas.every(agenda => agenda.profissionais.length === 0)
          "
          data-cy="agendar-alert-no-agenda-date"
        >
          Não foi possível encontrar uma agenda com esse profissional até a data:
          {{ lastDate | date }}.
        </div>
        <div
          class="alert alert-primary"
          role="alert"
          v-else-if="agendas.every(agenda => agenda.profissionais.length === 0)"
          data-cy="agendar-alert-no-agenda"
        >
          Não foi possível encontrar uma agenda com esse profissional.
        </div>
      </div>
    </div>

    <div v-if="lastDate" data-cy="agendar-nextdate-container">
      <button
        @click="nextPage"
        :disabled="carregandoMaisDatas"
        class="btn btn-outline-secondary"
        data-cy="agendar-nextdate-btn"
      >
        Carregar datas após {{ lastDate | date }}
      </button>
    </div>
  </b-col>
</template>

<script>
import AgendaGeralMain from "@/components/agenda-geral-main.vue";
import BackButton from "@/components/back-button.vue";
import SearchFilter from "@/components/filter.vue";
import LoadingOverlay from "@/components/loading-overlay.vue";
import { generateTo } from "@/core/routerHelper";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "agendar",
  data() {
    return {
      carregandoMaisDatas: false,
      tabDateTime: true,
      tabProfessional: false
    };
  },
  components: {
    AgendaGeralMain,
    SearchFilter,
    BackButton,
    LoadingOverlay
  },
  computed: {
    ...mapGetters("loading", ["isLoading"]),
    
    datetime() {
      return this.$store.getters.get_selected[3];
    },
    agendas() {
      return this.$store.getters.get_schedules;
    },
    lastDate() {
      if (this.agendas.length) {
        const lastSchedule = this.agendas[this.agendas.length - 1];
        return lastSchedule.data;
      }

      return null;
    }
  },
  methods: {
    tabClick(id) {
      this.tabDateTime = id === "tab-header-datahora";
      this.tabProfessional = id === "tab-header-professional";

      if (this.tabDateTime) {
        this.loadSchedules();
      }
    },
    loadSchedules() {
      let payload = {
        params: {
          organizationId: this.$route.params.organizationId
        }
      };

      this.$store.dispatch("load_schedules", payload).catch(error => {
        this.$bvToast.toast(error.response.data.message, {
          title: "Erro",
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true
        });
      });
    },
    async nextPage() {
      this.carregandoMaisDatas = true;
      let payload = {
        params: {
          organizationId: this.$route.params.organizationId
        },
        date: moment(this.lastDate)
          .add(1, "d")
          .format("YYYY-MM-DD")
      };

      this.$store.dispatch("set_loading", true);
      await this.$store.dispatch("load_moreschedules", payload).catch(error => {
        this.$bvToast.toast(error.response.data.message, {
          title: "Erro",
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true
        });
      });
      this.carregandoMaisDatas = false;
    }
  },
  filters: {
    date(val) {
      return moment(val).format("DD/MM/YYYY");
    }
  },
  mounted() {
    this.loadSchedules();

    this.$store.dispatch("set_actual", this.$route.fullPath);
    this.$store.dispatch("set_from", {
      name: generateTo(3, this.$route),
      params: { organizationId: this.$route.params.organizationId },
      query: {
        convenio: this.$route.query.convenio,
        especialidade: this.$route.query.especialidade
      }
    });

    if (this.datetime.nome) {
      this.$store.dispatch("set_to", {
        name: "consulta_profissional",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.$route.query.convenio,
          especialidade: this.$route.query.especialidade,
          clinica: this.$route.query.clinica,
          horario: this.datetime.id
        }
      });
    } else {
      this.$store.dispatch("set_to", "");
    }
  }
};
</script>
